import { useEffect } from 'react';
import { ACCOUNT_TYPES, APP_MODES, DEAL_ROLES, ROLES, USER_RESTRICTIONS } from '@/helpers/constants';
import { useGetProfile } from '@/query/queries/user/useGetProfile';
import { useUserStore } from '@/store/userStore';

export const useGetMe = () => {
  const { accessToken, mode, setMode, accountType, setAccountType } = useUserStore();
  const { data: profile, isLoading, refetch: refetchProfile } = useGetProfile();

  const dealRoles = profile?.user.deal_roles;
  const isLender = !!dealRoles?.includes(DEAL_ROLES.lender);
  const isBorrower = !!dealRoles?.includes(DEAL_ROLES.borrower);
  const isGuarantor = !!dealRoles?.includes(DEAL_ROLES.guarantor);

  const restrictions = {
    [ACCOUNT_TYPES.personal]: profile?.user.restrictions || [],
    [ACCOUNT_TYPES.business]: profile?.user.business_restrictions || [],
  };
  const hasRestriction = (accountType, restriction) =>
    !!restrictions[accountType]?.includes(restriction);
  const hasAddCashRestriction = hasRestriction(ACCOUNT_TYPES.business, USER_RESTRICTIONS.add_cash);
  const isWithdrawRestricted = accountType =>
    hasRestriction(accountType, USER_RESTRICTIONS.withdraw);

  useEffect(() => {
    if (!mode && profile) {
      setMode(profile.user.application_mode);
    }
  }, [profile, mode, setMode]);

  useEffect(() => {
    if (!accountType && profile) {
      if (profile.user.application_mode === APP_MODES.split && isLender) {
        setAccountType(ACCOUNT_TYPES.personal);
        return;
      }
      setAccountType(ACCOUNT_TYPES.business);
    }
  }, [profile, accountType, isLender, setAccountType]);

  return {
    accessToken,
    user: profile?.user,
    role: profile?.user.role,
    profile,
    isLoading,
    refetchProfile,
    isMainFounder: profile?.user.role === ROLES.founder,
    isCoFounder: profile?.user.role === ROLES.co_founder,
    isFinance: profile?.user.role === ROLES.finance,
    isLender,
    isBorrower,
    isGuarantor,
    hasAddCashRestriction,
    isWithdrawRestricted,
    isCombinedMode: profile?.user.application_mode === APP_MODES.combined,
    isSplitMode: profile?.user.application_mode === APP_MODES.split,
  };
};
